import React, { useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faEye, faEyeSlash, faLock } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/bs5/unstyled_dropdown_toggle';

const DROPDOWN_OPTIONS = [
  { label: 'Low', level: 'low', icon: faLock },
  { label: 'Medium', level: 'medium', icon: faLock },
  { label: 'High', level: 'high', icon: faLock },
  { label: 'Private', level: 'private', icon: faEyeSlash },
  { label: 'Public', level: 'public_access', icon: faEye },
];

export default function NestedBulkItemDropdown({ elementId, nestedType, showPrefix, onClick }) {
  const upperCaseNestedType = nestedType.charAt(0).toUpperCase() + nestedType.slice(1);
  const [showNestedDropdown, setShowNestedDropdown] = useState(false);
  const hideNestedDropdownRef = useRef();

  function hideNestedDropdown() {
    clearTimeout(hideNestedDropdownRef.current);

    hideNestedDropdownRef.current = setTimeout(() => {
      setShowNestedDropdown(false);
    }, 250);
  }

  function openNestedDropdown() {
    clearTimeout(hideNestedDropdownRef.current);
    setShowNestedDropdown(true);
  }

  return (
    <li>
      <Dropdown
        drop="end"
        id={elementId}
        show={showNestedDropdown}
        style={{ cursor: 'pointer' }}
        onMouseLeave={hideNestedDropdown}
        onMouseOver={openNestedDropdown}
      >
        <Dropdown.Item className="px-4 py-2">
          <Dropdown.Toggle as={UnstyledDropdownToggle}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <FontAwesomeIcon className="icon-container" icon={faLock}/>
                Change {showPrefix ? upperCaseNestedType : ''} Access Level
              </div>
              <FontAwesomeIcon className="ml-3" icon={faChevronRight}/>
            </div>
          </Dropdown.Toggle>
        </Dropdown.Item>

        <Dropdown.Menu as="ul">
          {DROPDOWN_OPTIONS.map(option => (
            <li key={option.level}>
              <Dropdown.Item className="px-4 py-2" onClick={() => onClick(option.level, nestedType)}>
                <FontAwesomeIcon className="icon-container" icon={option.icon}/>
                {showPrefix ? upperCaseNestedType : ''} Access Level: {option.label}
              </Dropdown.Item>
            </li>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </li>
  );
}

NestedBulkItemDropdown.propTypes = {
  elementId: PropTypes.string.isRequired,
  nestedType: PropTypes.string.isRequired,
  showPrefix: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
